import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=d960adee&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d960adee')) {
      api.createRecord('d960adee', component.options)
    } else {
      api.reload('d960adee', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=d960adee&", function () {
      api.rerender('d960adee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading/loading.vue"
export default component.exports